import { Link } from "react-router-dom";
import { OptimizedImage } from "@/components/OptimizedImage";

interface AuthorBylineProps {
  name: string;
  title: string;
  bio: string;
  image?: string;
}

export const AuthorByline = ({ name, title, bio, image }: AuthorBylineProps) => {
  return (
    <div className="my-8 p-6 bg-muted/50 rounded-lg border">
      <div className="flex items-start gap-4">
        {image && (
          <OptimizedImage 
            src={image} 
            alt={`Gewerbefläche mieten 2026 – Expertin ${name}, ${title}`}
            width={64}
            height={64}
            className="w-16 h-16 rounded-full object-cover"
          />
        )}
        <div>
          <Link to="/ueber-uns" className="font-semibold text-primary hover:underline">{name}</Link>
          <p className="text-sm text-muted-foreground mb-2">{title}</p>
          <p className="text-sm text-muted-foreground">{bio}</p>
          <Link to="/ueber-uns" className="text-sm text-primary hover:underline mt-2 inline-block">
            Mehr über unser Redaktionsteam →
          </Link>
        </div>
      </div>
    </div>
  );
};
